import { RateAgreementBulkUpsertLandingComponent } from './rate-agreement-bulk-upsert-landing.component';

export const containers: any[] = [RateAgreementBulkUpsertLandingComponent];

export * from './rate-agreement-bulk-upsert-landing.component';